import { OrganizationApi } from '../../../api';
import { LeaveRequestType } from '../../../commonTypes/leaveRequest.types';
import { MedicalLeaveRequirementsExtended } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';

const useHttpGetMedicalLeaveByOrganizationOnMount = (organizationId: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [medicalLeave, setMedicalLeave] = useState<MedicalLeaveRequirementsExtended>();

    useEffect(() => {
        const { exec, abort } = organizationApi.getMedicalLeaveByOrganization({
            params: { organizationId },
            onSuccess: res =>
                setMedicalLeave({
                    ...res.body,
                    leaveType: LeaveRequestType.MEDICAL_LEAVE,
                }),
            onError: error => error,
        });
        exec();
        return abort;
    }, []);

    return { medicalLeave, setMedicalLeave };
};

export default useHttpGetMedicalLeaveByOrganizationOnMount;
